export default __webpack_public_path__ + "static/haleon_white-80f9f06759e0214a5e96090bb32ae298.png";